export enum answerQuestionsStatus {
    'Desativado',
    'Ativado',
    'Somente leitura'
}
